// angular
import { isPlatformBrowser } from '@angular/common';
import {
  AfterContentInit,
  Component,
  ElementRef,
  inject,
  input,
  output,
  PLATFORM_ID,
} from '@angular/core';
// spinner
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'pwj-pagination-on-scroll',
  standalone: true,
  imports: [NgxSpinnerModule],
  templateUrl: './pagination-on-scroll.component.html',
  styleUrl: './pagination-on-scroll.component.scss',
})
export class PaginationOnScrollComponent implements AfterContentInit {
  public pages: number = 0;
  public currentPage!: number;

  // inputs
  dataCount = input.required<number>();
  perPage = input<number>(10);
  resetCurrentPage = input<boolean>(false);

  // outputs
  setCurrentPage = output<number>();

  // dependencies
  private readonly elementRef = inject(ElementRef);
  private readonly _spinner = inject(NgxSpinnerService);
  private readonly platformId = inject(PLATFORM_ID);

  constructor() {}

  ngAfterContentInit(): void {
    if (this.dataCount()) {
      this.pages = Math.round(this.dataCount() / this.perPage());
    }

    if (this.resetCurrentPage()) {
      this.currentPage = 0;
    }

    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const element = this.elementRef.nativeElement;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.navigateToNextPage();
        } else {
          this._spinner.hide();
        }
      });
    });

    observer.observe(element);
  }

  public navigateToNextPage() {
    if (!this.currentPage || this.currentPage < this.pages) {
      this.currentPage = (this.currentPage || 0) + 1;
      this.setCurrentPage.emit(this.currentPage);
    }
  }
}
